import { createReducer } from "../../common/reduxUtil";
import { UPDATE_FOLLOW_COUNT } from "./types";

const initialState = {
  followersCount: 0,
  tagline: "",
};

export default createReducer(initialState, {
  [UPDATE_FOLLOW_COUNT]: (state, payload) => {
    return Object.assign({}, state, {
      ...state,
      followersCount: payload.followersCount,
    });
  },
});
